import { ref } from 'vue';
import toast from '@kk/toast';
export function useOffline () {
  const showOffline = ref(false);
  // 2022/12/05 00:00:00 下线
  const offlineTime = Number(new Date(1670169600000));
  const nowTime = Number(new Date());
  if (nowTime > offlineTime) {
    showOffline.value = true;
  }
  function offlineToast (txt: string) {
    toast.show({
      text: txt,
      time: 2000
    });
  }
  return {
    showOffline,
    offlineToast
  };
}